import gtm from 'eco-design-reliance/gtm';
import { ItfGTM29Entire, ItfGTM29 } from './type';

// https://ecoflow.feishu.cn/wiki/GXWPwndwGi5lkMk5fn7cG5CNnXI 新版埋点
export const handle_GTM_29 = (data: ItfGTM29) => {
    gtm.push({ ...data, event: 'uaEvent', event_name: 'sidebar_add_to_cart' } as ItfGTM29Entire);
};
